import { Loader2 } from 'lucide-react';

export function Loading({ label = 'Loading…' }: { label?: string }) {
  return (
    <div className="flex flex-col items-center justify-center gap-2 py-12 text-text-tertiary">
      <Loader2 className="h-6 w-6 animate-spin text-brand-primary" />
      <span className="text-sm">{label}</span>
    </div>
  );
}
